import { configureStore } from '@reduxjs/toolkit';
import { settingsSlice } from '../slices/settingsSlice';
import { leaguesSlice } from '../slices/leaguesSlices';
import { authSlice } from '../slices/auth';
import { teamsSlice } from '../slices/teamsSlice';
import { tipsSlice } from '../slices/tipsSlice';
import { cappersSlice } from '../slices/cappersSlice';
import { bettorsSlice } from '../slices/bettorSlice';

export default configureStore({
  reducer: {
    user: authSlice.reducer,
    leagues: leaguesSlice.reducer,
    teams: teamsSlice.reducer,
    tips: tipsSlice.reducer,
    cappers: cappersSlice.reducer,
    bettors: bettorsSlice.reducer,
    settings: settingsSlice.reducer
  }
});
